<template>
<v-card flat width="100%">
    <v-card-title>
        {{title}}
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <!-- Dialog for confirm delete user -->
    <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
        <v-card>
            <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
            <v-card-actions v-if="dialogItem.confirmAction">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-actions v-else>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                <v-btn color="blue darken-1" text @click="actionDeleteItem">Yes</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <!-- @click:row="goToMemberDetails" -->
    <v-data-table :headers="headers" :search="search" :items="userList" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading">
        <template v-slot:[`item.avatar`]="{ item }">
            <v-avatar v-if="item.pictureUrl" size="32" class="mr-2">
                <img :src="item.pictureUrl" />
            </v-avatar>
            <v-avatar v-if="!item.pictureUrl" color="info" size="32" class="mr-2">
                <v-icon dark> mdi-account-circle </v-icon>
            </v-avatar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
            <v-icon class="mr-2" @click="dialogDeleteItem(item)" title="Delete">
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
</v-card>
</template>

<script>
import formatData from "../utils/formatData";
import setProgramInfo from "../data/setProgramInfo";
import bqGetCoachListByProgramId from "../data/bqGetCoachListByProgramId";
import {
    mapGetters
} from "vuex";
export default {
    data() {
        return {
            title: 'Coach List',
            headers: [{
                    text: "",
                    value: "avatar",
                    sortable: false,
                },
                {
                    text: "ชื่อโค้ช",
                    value: "name",
                    cellClass: "pr-0",
                },
                {
                    text: "Organization",
                    value: "org",
                    align: "center"
                },
                {
                    text: "Action",
                    value: "actions",
                    sortable: false,
                }
            ],
            search: "",
            options: {
                itemsPerPage: 20,
            },
            dialogItem: {
                confirmAction: false,
                confirmText: "Do you want to remove this coach?",
                deleteConfirmation: false,
                deletedItemId: null,
            },
            dialogItemDefault: {
                confirmAction: false,
                confirmText: "Do you want to remove this coach?",
                deleteConfirmation: false,
                deletedItemId: null,
                deletedProgramId: null
            },
            editable: false,
            status: '',
            userList: [],
            editedItem: {
                coachList: [],
                updatedBy: '',
                updatedDate: ''
            }
        };
    },
    created() {
        (async () => {
            this.userList = await bqGetCoachListByProgramId(this.programId);
        })();
    },
    computed: {
        ...mapGetters([
            "isAuthenticated",
            "loggedInUserId",
            "isSuperAdmin",
            "isChallengeAdmin",
            "isAccessOrgAdmin"
        ]),
        loading() {
            return this.$attrs.loading;
        },
        programId() {
            return this.$attrs.programId;
        },
    },
    methods: {
        _formatData(type, value) {
            return formatData(type, value);
        },
        // //delete
        dialogDeleteItem(item) {
            this.dialogItem.deleteConfirmation = true; //show popup
            this.dialogItem.deletedItemId = item.uid; //assign delete item id

            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },
        actionDeleteItem() {
            (async () => {
                const copyItems = [];
                // using for loop
                const coachListSelected = [];
                for (let i = 0; i < this.userList.length; i++) {
                    if( this.userList[i].uid != this.dialogItem.deletedItemId ){
                        copyItems.push(this.userList[i]);
                        coachListSelected.push(this.userList[i].uid);
                    }
                }
                this.userList = copyItems;
                this.editedItem.coachList = coachListSelected;

                this.editedItem.updatedDate = new Date();
                this.editedItem.updatedBy = this.loggedInUserId;
                await setProgramInfo(this.editedItem, this.programId);
                this.dialogItem.deleteConfirmation = false;
            })();
        },
        closeConfirmationDialog() {
            //To result default value
            this.dialogItem.deleteConfirmation = false;
            this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
            this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
            this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
        },

    }
};
</script>
